// extracted by css-extract-rspack-plugin
export default {"tooltipIcon":"sTERy6t0COQWmeYs","outline":"JQ4I8r4XXErl0RWW","fill":"EvDylL6SKY2rkw41"};